import { FunctionComponent, useState } from "react";

import { Modal } from "@/components/Modals/Modal";

import { Dropdown } from "@/components/Dropdown/Dropdown";

import { useUpdateProspectMutation } from "@/pages/Private/redux/list/list.api";

import { useHasPermissions } from "@/utils/useHasPermissions";
import { PermissionRoles } from "@/enum/permissions";

import { ListPerson } from "../../schema/list";

export const ModalChangeSeniority: FunctionComponent<{
	listPerson: ListPerson;
	handleCopyClick: (value: string) => void;
	row: ListPerson;
}> = ({ listPerson, row }) => {
	const { hasPermissions } = useHasPermissions();

	const [showModal, setShowModal] = useState(false);
	const [updateProspect, { isLoading }] = useUpdateProspectMutation();

	const [selectedSeniority, setSelectedSeniority] = useState<
		{ id: string; title: string } | undefined
	>();

	const handleClose = () => {
		setShowModal(false);
	};

	const handleSave = async () => {
		if (selectedSeniority?.id) {
			await updateProspect({
				id: listPerson.id,
				...{ seniority: selectedSeniority?.id },
			}).unwrap();
		}

		handleClose();
	};

	return (
		<div
			className="flex items-center cursor-pointer"
			onClick={(e) => {
				e.preventDefault();
				e.stopPropagation();

				if (hasPermissions([PermissionRoles.GLOBAL_ADMIN])) {
					setShowModal(true);
				}
			}}
		>
			<div>
				<button className="text-ellipsis overflow-hidden max-w-[250px] cursor-pointer">
					{row.prospect?.jobTitleToSeniority?.seniority}
				</button>
			</div>
			{hasPermissions([PermissionRoles.GLOBAL_ADMIN]) && (
				<Modal
					handleClose={(e) => {
						e.preventDefault();
						e.stopPropagation();

						handleClose();
					}}
					handleSave={handleSave}
					isLoading={isLoading}
					isOpened={showModal}
					title="Change Seniority"
				>
					<div>
						<div className="text-sm font-bold">
							Change seniority for {listPerson?.prospect?.name}
						</div>
						<Dropdown
							data={[
								{
									id: "Intern/Student",
									title: "Intern/Student",
								},
								{
									id: "Entry-Level",
									title: "Entry-Level",
								},
								{
									id: "Mid-Level",
									title: "Mid-Level",
								},
								{
									id: "Senior",
									title: "Senior",
								},
								{
									id: "Head of / Team Lead",
									title: "Head of / Team Lead",
								},
								{
									id: "Director",
									title: "Director",
								},
								{
									id: "VP",
									title: "VP",
								},
								{
									id: "Partner",
									title: "Partner",
								},
								{
									id: "C-Suite (excl. CEO, MD, Founder & Board)",
									title: "C-Suite (excl. CEO, MD, Founder & Board)",
								},
								{
									id: "CEO/Founder/Owner/Board Member",
									title: "CEO/Founder/Owner/Board Member",
								},
							]}
							defaultValue={
								listPerson?.prospect?.jobTitleToSeniority?.seniority
									? {
											id: listPerson?.prospect?.jobTitleToSeniority?.seniority,
											title: listPerson?.prospect?.jobTitleToSeniority?.seniority,
										}
									: listPerson?.prospect?.seniority
										? {
												id: listPerson?.prospect?.seniority,
												title: listPerson?.prospect?.seniority,
											}
										: undefined
							}
							floating={false}
							handleSelect={(selected) => {
								if (selected.id) {
									setSelectedSeniority({
										id: selected.id as string,
										title: selected.title,
									});
								}
							}}
							label="Seniority"
						/>
					</div>
				</Modal>
			)}
		</div>
	);
};
